import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../../templates/Ui';
const StyledAvatar = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    font-size: 18px;
    font-weight: 700;
    margin-right: 10px;
    background-color: ${props => props.variant === 'inkassier'
    ? props => props.theme.primary
    : '#E6EBEE'};
    color: ${props => props.variant === 'inkassier'
    ? color.body.base
    : props => props.theme.primary.base};
`;
const Avatar = ({ initials, variant }) => {
    return _jsx(StyledAvatar, { variant: variant, children: initials });
};
export default Avatar;
